import { requestClient } from '#/api/request';

// 买家号列表
export async function buyerListApi(data = {}) {
  return requestClient.post('/merchant/buyer/list', data);
}

// 添加买家号
export async function addBuyerApi(data = {}) {
  return requestClient.post('/merchant/buyer/add', data);
}

// 修改买家号状态
export async function updateBuyerStatusApi(data = {}) {
  return requestClient.post('/merchant/buyer/update-account-status', data);
}

// 修改买家号
export async function updateBuyerApi(data = {}) {
  return requestClient.post('/merchant/buyer/update', data);
}
